import { z } from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { Mail, Lock } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { useAuthStore } from '@/features/auth/store/auth-store'
import { useAuth } from '../../hooks/use-auth'

const passwordSchema = z.object({
  email: z.string().email('请输入有效的邮箱地址'),
  password: z.string().min(6, '密码长度至少为6位'),
})

export function LoginEmailPasswordForm() {
  const { handleLogin } = useAuthStore((s) => s.handlers)
  const { authLoginMutationAsync } = useAuth()

  const form = useForm<z.infer<typeof passwordSchema>>({
    resolver: zodResolver(passwordSchema),
    defaultValues: { email: '', password: '' },
  })

  async function onPasswordSubmit(data: z.infer<typeof passwordSchema>) {
    await handleLogin(data, authLoginMutationAsync)
  }

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onPasswordSubmit)}
        className='grid gap-4'
      >
        <FormField
          control={form.control}
          name='email'
          render={({ field }) => (
            <FormItem>
              <FormLabel className='sr-only'>邮箱</FormLabel>
              <FormControl>
                <div className='relative'>
                  <Mail className='text-muted-foreground absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2' />
                  <Input
                    {...field}
                    className='bg-muted focus-visible:ring-primary h-12 border-none pl-10 focus-visible:ring-1'
                    placeholder='请输入邮箱地址'
                  />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name='password'
          render={({ field }) => (
            <FormItem>
              <FormLabel className='sr-only'>密码</FormLabel>
              <FormControl>
                <div className='relative'>
                  <Lock className='text-muted-foreground absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2' />
                  <Input
                    {...field}
                    type='password'
                    className='bg-muted focus-visible:ring-primary h-12 border-none pl-10 focus-visible:ring-1'
                    placeholder='请输入您的密码'
                  />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <Button
          type='submit'
          className='h-12 w-full text-base font-medium'
          disabled={form.formState.isSubmitting}
        >
          登录
        </Button>
      </form>
    </Form>
  )
}
